import classNames from "@calcom/ui/classNames";

/** Knopka book.knopka.click brand — not tied to upstream APP_NAME default (Cal.diy). */
const KNOPKA_BRAND = "Календарь ツ";
const KNOPKA_ICON_MARK = "ツ";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src: _src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  /** @deprecated Knopka uses text brand; kept for upstream call-site compatibility. */
  src?: string;
}) {
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <span
            className="text-brand mx-auto flex h-9 w-9 items-center justify-center rounded-lg bg-brand/10 text-xl font-bold"
            aria-label={KNOPKA_BRAND}
            title={KNOPKA_BRAND}>
            {KNOPKA_ICON_MARK}
          </span>
        ) : (
          <span
            className={classNames(
              "text-brand font-cal font-semibold tracking-tight whitespace-nowrap",
              small ? "text-sm" : "text-base"
            )}
            aria-label={KNOPKA_BRAND}
            title={KNOPKA_BRAND}>
            {KNOPKA_BRAND}
          </span>
        )}
      </strong>
    </h3>
  );
}
